/*
 * @Author: lyx
 * @Date: 2024-08-15 14:25:17
 * @LastEditors: lyx
 * @LastEditTime:  2024-08-15 14:25:17
 * @FilePath: /dbrank_b/src/routes/visualChart/P32/index.js
 */

import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./index.css";
import Stage from "../components/Stage";
import setChart from "./chart";
import Chart from "../components/Chart";
import { Title32 } from "../components/Titles";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./Form";

class P32 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartList: [],
      chartAxis: [],
      chartColorList: []
    };
  }
  render() {
    const { chartList, chartAxis, chartColorList } = this.state;
   
    return (
      <Stage>
        <Title32 pageNumber="2">卡萨帝 VS 竞品 | 传播可见度分析
        </Title32>
        <div className={s.content}>
          <div>
            <div contentEditable className={s.des} style={{marginTop: "18px"}}>
              监测期内，卡萨帝及竞品的传播可见度（指有效内容（包括高效/顶流）在全部内容中所占比例）排名依次为：COLMO（<span className={s.emphasis}>11.79%</span>）、卡萨帝（<span className={s.emphasis}>11.70%</span>）、松下（<span className={s.emphasis}>10.05%</span>）、西门子（<span className={s.emphasis}>7.04%</span>）、博世（<span className={s.emphasis}>5.52%</span>）。卡萨帝排名第二，与COLMO相差<span className={s.emphasis}>0.09%</span>。
            </div>
            <div contentEditable className={s.des} style={{marginTop: "10px"}}>
              卡萨帝的有效内容、高效内容和顶流内容篇数共计<span className={s.emphasis}>10,630</span>条，远高于竞品，表明传播内容受到用户广泛关注。但与此同时，卡萨帝无效内容和低效内容篇数之和也为竞品中最高，占比达到<span className={s.emphasis}>88.30%</span>。COLMO的有效内容、高效内容和顶流内容共708篇，在竞品中排名最末，但由于整体传播内容数量最少，传播可见度排名最高。
            </div>
          </div>

          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: "100%", height: "100%" }}
              formContent={
                <Form onChange={(values) => this.setState({ ...values })} />
              }
            >
              <Chart
                isShow
                options={setChart({
                  chartAxis: chartAxis,
                  chartList: chartList,
                  color: chartColorList,
                })}
              />
            </TooltipDrawer>
          </div>
          <div contentEditable className={s.explain}>
            注：传播可见度仅统计情感倾向为推荐/好感/中立的非转载内容。
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P32);



// WEBPACK FOOTER //
// src/routes/visualChart/P32/index.js